import { render, staticRenderFns } from "./WSingleBarSimple.vue?vue&type=template&id=ec00da00&"
import script from "./WSingleBarSimple.vue?vue&type=script&lang=js&"
export * from "./WSingleBarSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports